import { ComponentStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps } from '@chakra-ui/theme-tools';

const NavBarTheme: ComponentStyleConfig = {
  baseStyle: (props: StyleFunctionProps) => {
    const { isActive, variant } = props;

    return {
      navBar: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 8px',
        minHeight: '56px',
        _dark: {
          backgroundColor: 'black.base'
        }
      },
      navBarLeftContainer: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '12px'
      },
      navBarRightContainer: {
        display: 'flex',
        alignItems: 'center',
        gridGap: '4px',
        paddingRight: '12px'
      },
      navBarTab: {
        margin: '0 4px',
        position: 'relative',
        height: '100%',
        padding: '8px 0',

        ...(isActive && {
          '&::before': {
            content: '""',
            width: '100%',
            height: '4px',
            backgroundColor: 'blue.base',
            position: 'absolute',
            bottom: 0,
            right: 0
          }
        })
      },
      navBarTabButton: {
        fontSize: '14px',

        _dark: {
          color: 'grey.lighter'
        },
        _hover: {
          _dark: {
            color: 'silver.lightest',
            backgroundColor: 'black.lightest'
          }
        },
        ...(isActive && {
          _dark: {
            color: 'silver.lightest'
          }
        })
      },
      navBarTabItem: {
        height: '40px',
        display: 'flex'
      },
      navBarIconButtonItem: {
        padding: '5px 0'
      },

      navBarIconMenuButton: {
        svg: {
          width: '24px',
          height: '24px'
        },
        ...(variant === 'primary' && {
          _dark: {
            backgroundColor: 'blue.base',
            _hover: {
              backgroundColor: 'blue.dark'
            },
            _active: {
              backgroundColor: 'blue.base'
            }
          }
        })
      }
    };
  }
};

export default NavBarTheme;
